var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"id":"first-connexion-modal","cancel-title":_vm.$t('Continue'),"ok-title":_vm.$t('Welcome.update.password'),"title":_vm.$t('Welcome'),"centered":"","cancel-variant":"primary","ok-variant":"danger"},on:{"ok":_vm.goToChangePasswordModal}},[_c('p',[_vm._v(_vm._s(_vm.$t('Welcome.message')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f997ba1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/FirstConnexionModal.vue
// module id = pS0n
// module chunks = 0